import React from "react";
import "../../main.css";

const CustomerTest = ({ record }) => {
  const condition_mapper = {
    10: "Better",
    5: "No Change",
    1: "Worse",
  };

  const luck_mapper = {
    10: "Good",
    5: "Ok",
    1: "Bad",
  };

  const scalp_feedback_mapper = {
    5: "Good, no issues.",
    1: "I have itching and dandruff.",
  };

  const hair_growth_mapper = {
    10: "Yes",
    5: "Better",
    1: "Not changed yet",
  };

  const dandruff_feedback_mapper = {
    10: "Much Better",
    5: "No Change",
    1: "Worse",
  };

  const preffered_language_mapper = {
    english: "English",
    hindi: "Hindi",
    telegu: "Telegu",
    tamil: "Tamil",
    kannada: "Kannada",
  };

  return (
    <>
      <div className="bg-white" key={record?._id}>
        <div className="d-flex gap-5 bg-primary justify-content-between align-items-center pe-4 text-white div-3 border rounded-2 ">
          <div className="flex-1 p-3">Questions</div>
          <div>
            <strong className="">Engagement Tag: </strong>
            <span className="p-2 my-2 border border-warning rounded-5 bg-white text-warning fw-bold px-3 py-1  ">
              {record?.tag ? record?.tag:"N/A"}
            </span>
          </div>
        </div>
      </div>
      <div
        className="scrollable-section"
        style={{ height: "78vh", overflowY: "auto" }}
      >
        <div className=" bg-white   ">
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="font-weight-bold">
                How is your overall mood and sleep these days?{" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                condition_mapper[record["mood"]]
                  ? "text-primary"
                  : "text-danger"
              }
            >
              {condition_mapper[record["mood"]] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="">
                Were you regular with your hair routine this month?
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                record?.customer_adherence
                  ? "text-primary px-1"
                  : "text-danger px-1"
              }
            >
              {record?.customer_adherence || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                Are you feeling lighter and more energetic than before (month
                1-4)?
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                condition_mapper[record?.energy]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {condition_mapper[record?.energy] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                How is your hair fall now?{" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                condition_mapper[record?.hair_loss]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {condition_mapper[record?.hair_loss] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                Were you able to follow Traya diet to some extent this month?
              </strong>
            </div>
            <div className={record?.diet ? "text-primary " : "text-danger "}>
              {record?.diet}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                How is your constipation now?(month 1-4){" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                condition_mapper[record?.constipation]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {condition_mapper[record?.constipation] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                How is bloating, gas, acidity now?{" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                condition_mapper[record?.digestion]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {condition_mapper[record?.digestion] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                How would you rate your Overall Health?{" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                luck_mapper[record?.overall_health]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {" "}
              {luck_mapper[record?.overall_health] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              {" "}
              <strong className="text-secondary fw-bold">
                How is your scalp health now?
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                scalp_feedback_mapper[record?.scalp_feedback]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {scalp_feedback_mapper[record?.scalp_feedback] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                {record?.user?.gender === "F"
                  ? "Do you feel your hair is more nourished and healthy now?"
                  : "Do you feel your hair are now thicker & healthier than before?"}
              </strong>
            </div>
            <div className="text-primary">
              {record?.hair_feedback === "yes" ? "Hurray Yes" : ""}
              {record?.hair_feedback === "no" ? "Not yet" : ""}
              {record?.hair_feedback === "" ? "N/A" : ""}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            {record?.user?.gender === "F" && (
              <div>
                <div>
                  <strong className="text-secondary fw-bold">
                    Has hair breakage reduced?{" "}
                  </strong>
                </div>
                <div>
                  {record?.hair_breakage === "yes" ? "Yes" : ""}
                  {record?.hair_breakage === "no" ? "Not change yet" : ""}
                  {record?.hair_breakage === "" ? "N/A" : ""}
                </div>
              </div>
            )}
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                {record?.user?.gender === "F"
                  ? "Do you see an increase in your hair volume?"
                  : "Do you see any new hair growth?"}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                hair_growth_mapper[record?.hair_growth]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {" "}
              {hair_growth_mapper[record?.hair_growth] || "N/A"}
            </div>
          </div>
          {record?.user?.gender === "M" && (
            <div className="px-2 border rounded my-2 p-2 ">
              <div>
                <strong className="text-secondary fw-bold">
                  Do you have any other concerns and want to get on a call with
                  a certified hair coach at Traya?.
                </strong>
              </div>
              <div
                className={record?.concerns ? "text-primary " : "text-danger "}
              >
                {" "}
                {record?.concerns}{" "}
              </div>
            </div>
          )}
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              {" "}
              <strong className="text-secondary fw-bold">
                Any change in dandruff?{" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                dandruff_feedback_mapper[record?.dandruff_feedback]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {dandruff_feedback_mapper[record?.dandruff_feedback] || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <strong className="text-secondary fw-bold">
              Are you seeing any improvement with your PCOS symptoms?{" "}
            </strong>
            <div
              style={{ fontWeight: "bold" }}
              className={
                record?.santulan_feedback ? "text-primary " : "text-danger "
              }
            >
              {record?.santulan_feedback || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              <strong className="text-secondary fw-bold">
                Are you happy with Traya?{" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                record?.happy_with_traya ? "text-primary " : "text-danger "
              }
            >
              {record?.happy_with_traya || "N/A"}
            </div>
          </div>
          <div className="px-2 border rounded my-2 p-2 ">
            <div>
              {" "}
              <strong className="text-secondary fw-bold">
                Choose your preferred Language, We will let your coach know
                about your choice.{" "}
              </strong>
            </div>
            <div
              style={{ fontWeight: "bold" }}
              className={
                preffered_language_mapper[record?.preffered_language]
                  ? "text-primary "
                  : "text-danger "
              }
            >
              {" "}
              {preffered_language_mapper[record?.preffered_language] || "N/A"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerTest;
